import React from 'react'
import PropTypes from 'prop-types'
import {
  Media,
  Text,
  Icon,
  IconManager,
  paymentMethodsIconPack,
  Price,
} from '@deseretbook/react-ui'

IconManager.register(paymentMethodsIconPack)

/** Map of card names to relevant icon name. */
const cardIcons = {
  'american express': 'ccAmex',
  master: 'ccMastercard',
  visa: 'ccVisa',
  discover: 'ccDiscover',
}

/**
 * Displays a payment source's details. Used any time you want to display info about
 * a payment source. Generally for selecting one or displaying one that is selected.
 *
 * @returns {function} PaymentSourceDetails component
 */
const PaymentSourceDetails = ({ source, amount }) => (
  <Media>
    <Media.Figure>
      <Icon name={cardIcons[(source.ccType || '').toLowerCase()] || 'ccGeneric'} size="medium" />
    </Media.Figure>
    <Media.Content>
      {/* If payment source is for gift cards or not */}
      {source.number ? (
        <div>
          <Text hasEllipsis isBold>
            Gift Card <Price value={amount} />
          </Text>
          <Text hasEllipsis>
            Ends with {source.number.substring(source.number.length - 4)}
          </Text>
        </div>
      ) : (
        <div>
          <Text hasEllipsis isBold>{source.name}</Text>
          <Text hasEllipsis>
            Ends with {source.lastDigits} <Text hasEllipsis size="tiny">(Expires {source.month}/{source.year})</Text>
          </Text>
        </div>
      )}
    </Media.Content>
  </Media>
)

PaymentSourceDetails.propTypes = {
  /** Payment Source instance */
  source: PropTypes.shape({
    ccType: PropTypes.string,
    month: PropTypes.string,
    year: PropTypes.string,
    name: PropTypes.string,
    lastDigits: PropTypes.string,
    number: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }),
  /** Value of payment source (only if source is a gift card) */
  amount: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
}

PaymentSourceDetails.defaultProps = {
  source: {},
  amount: 0,
}

export default PaymentSourceDetails
